import * as Styled from './styles'

export default function titleRoxo({ children }) {
  return <Styled.TitleRoxo>{children}</Styled.TitleRoxo>
}
